import React, { useState, useCallback } from 'react';
import styled from 'styled-components';
import Search, { type SearchChangeHandler } from '@splunk/react-ui/Search';

const SearchContainer = styled.div`
    height: 50px;
    width: 100%;
    padding: 5px 0px;
`;

export interface GallerySearchProps {
    onSearch?: (value?: string) => void;
    disabled?: boolean;
}

const GallerySearch = React.forwardRef<HTMLInputElement, GallerySearchProps>(
    ({ onSearch, disabled }, ref) => {
        const [search, setSearch] = useState('');

        const handleSearch = useCallback<SearchChangeHandler>(
            (event, { value }) => {
                setSearch(value);
                onSearch?.(value);
            },
            [onSearch]
        );

        if (!onSearch) {
            return null;
        }

        return (
            <SearchContainer>
                <Search
                    inputRef={ref}
                    value={`${search}`}
                    disabled={disabled}
                    onChange={handleSearch}
                    data-test="gallery-search"
                />
            </SearchContainer>
        );
    }
);

export default GallerySearch;
